// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as RenderIf$OrcaPaymentPage from "./RenderIf.bs.js";
import * as CardUtils$OrcaPaymentPage from "../CardUtils.bs.js";
import * as TestUtils$OrcaPaymentPage from "../Utilities/TestUtils.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "../Utilities/JotaiAtoms.bs.js";
import * as PaymentInputField$OrcaPaymentPage from "./PaymentInputField.bs.js";

function CardFields(props) {
  let __isBancontact = props.isBancontact;
  let cvcProps = props.cvcProps;
  let expiryProps = props.expiryProps;
  let cardProps = props.cardProps;
  let __isBancontact_value = __isBancontact !== undefined ? __isBancontact : false;
  let match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  let localeString = match.localeString;
  let themeObj = match.themeObj;
  let match$1 = match.config.appearance;
  let innerLayout = match$1.innerLayout;
  let match$2 = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.optionAtom);
  let layoutClass = CardUtils$OrcaPaymentPage.getLayoutClass(match$2.layout);
  let cvcError = cvcProps.cvcError;
  let cvcNumber = cvcProps.cvcNumber;
  let isCVCValid = cvcProps.isCVCValid;
  let expiryError = expiryProps.expiryError;
  let cardError = cardProps.cardError;
  let isCvcValidValue = CardUtils$OrcaPaymentPage.getBoolOptionVal(isCVCValid);
  let match$3 = CardUtils$OrcaPaymentPage.useCardDetails(cvcNumber, isCvcValidValue, isCVCValid);
  let compressedLayoutStyleForCvcError = innerLayout === "Compressed" && cvcError.length > 0 ? "!border-l-0" : "";
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(RenderIf$OrcaPaymentPage.make, {
        condition: innerLayout === "Compressed",
        children: JsxRuntime.jsx("div", {
          children: localeString.cardHeader,
          style: {
            fontSize: themeObj.fontSizeLg,
            marginBottom: "5px",
            opacity: "0.6"
          }
        })
      }),
      JsxRuntime.jsxs(RenderIf$OrcaPaymentPage.make, {
        condition: !__isBancontact_value,
        children: [
          JsxRuntime.jsx(PaymentInputField$OrcaPaymentPage.make, {
            isValid: Primitive_option.some(cardProps.isCardValid),
            setIsValid: cardProps.setIsCardValid,
            value: cardProps.cardNumber,
            onChange: cardProps.changeCardNumber,
            onBlur: cardProps.handleCardBlur,
            rightIcon: cardProps.icon,
            errorString: cardError,
            fieldName: localeString.cardNumberLabel,
            name: TestUtils$OrcaPaymentPage.cardNoInputTestId,
            type_: "tel",
            maxLength: cardProps.maxCardLength,
            placeholder: "1234 1234 1234 1234",
            className: innerLayout === "Compressed" && cardError.length > 0 ? "border-b-0" : "",
            inputRef: cardProps.cardRef,
            autocomplete: "cc-number"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx(PaymentInputField$OrcaPaymentPage.make, {
                  isValid: Primitive_option.some(expiryProps.isExpiryValid),
                  setIsValid: expiryProps.setIsExpiryValid,
                  value: expiryProps.cardExpiry,
                  onChange: expiryProps.changeCardExpiry,
                  onBlur: expiryProps.handleExpiryBlur,
                  errorString: expiryError,
                  fieldName: localeString.validThruText,
                  name: TestUtils$OrcaPaymentPage.expiryInputTestId,
                  type_: "tel",
                  maxLength: 7,
                  placeholder: localeString.expiryPlaceholder,
                  inputRef: expiryProps.expiryRef,
                  autocomplete: "cc-exp"
                }),
                className: innerLayout === "Spaced" ? "w-[47%]" : "w-[50%]"
              }),
              JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx(PaymentInputField$OrcaPaymentPage.make, {
                  isValid: Primitive_option.some(isCVCValid),
                  setIsValid: cvcProps.setIsCVCValid,
                  value: cvcNumber,
                  onChange: cvcProps.changeCVCNumber,
                  onBlur: cvcProps.handleCVCBlur,
                  rightIcon: CardUtils$OrcaPaymentPage.setRightIconForCvc(match$3[0], match$3[2], themeObj.colorIconCardCvcError, match$3[1], layoutClass.cvcIcon),
                  errorString: cvcError,
                  fieldName: localeString.cvcTextLabel,
                  name: TestUtils$OrcaPaymentPage.cardCVVInputTestId,
                  type_: "tel",
                  maxLength: cvcProps.maxCVCLength,
                  placeholder: "123",
                  className: `tracking-widest w-full ` + compressedLayoutStyleForCvcError,
                  inputRef: cvcProps.cvcRef,
                  autocomplete: "cc-csc"
                }),
                className: innerLayout === "Spaced" ? "w-[47%]" : "w-[50%]"
              })
            ],
            className: "flex flex-row w-full place-content-between",
            style: {
              gridColumnGap: innerLayout === "Spaced" ? themeObj.spacingGridRow : ""
            }
          }),
          JsxRuntime.jsx(RenderIf$OrcaPaymentPage.make, {
            condition: innerLayout === "Compressed" && (cardError.length > 0 || cvcError.length > 0 || expiryError.length > 0),
            children: JsxRuntime.jsx("div", {
              children: "Invalid input",
              className: "Error pt-1",
              style: {
                alignSelf: "start",
                color: themeObj.colorDangerText,
                fontSize: themeObj.fontSizeSm,
                textAlign: "left"
              }
            })
          })
        ]
      })
    ]
  });
}

let make = CardFields;

export {
  make,
}
/* jotai Not a pure module */
